/* eslint-disable default-param-last */
const initialState = {
    liffId: '',
    logSessionToken: '',
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["AUTH_LIFF_ID_INIT"] = "auth/liffId/init";
    ACTION_TYPES["AUTH_LOG_SESSION_TOKEN_INIT"] = "auth/logSessionToken/init";
})(ACTION_TYPES || (ACTION_TYPES = {}));
/**
 * Reducer
 * @param {object} state
 * @param {object} action
 * @returns {object} new state
 */
export default function authReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_TYPES.AUTH_LIFF_ID_INIT:
            return { ...state, liffId: payload };
        case ACTION_TYPES.AUTH_LOG_SESSION_TOKEN_INIT:
            return { ...state, logSessionToken: payload };
        default:
            return state;
    }
}
// action creators
export const authLiffIdInit = (payload) => ({
    type: ACTION_TYPES.AUTH_LIFF_ID_INIT,
    payload,
});
export const authLogSessionTokenInit = (payload) => ({
    type: ACTION_TYPES.AUTH_LOG_SESSION_TOKEN_INIT,
    payload,
});
// selectors
export const selectLiffId = (state) => state.auth.liffId;
export const selectLogSessionToken = (state) => state.auth.logSessionToken;
